export const messageExtensionAppInstalledTitle = "jn5Jde";
export const messageExtensionAppInstalledSubTitle = "BfmExc";
export const messageExtensionAppInstalledCloseButtonLabel = "NE3WXd";
export const appHostDiagnosticDataDescription = "cWK3jc";
export default {messageExtensionAppInstalledTitle,messageExtensionAppInstalledSubTitle,messageExtensionAppInstalledCloseButtonLabel,appHostDiagnosticDataDescription};